export default __webpack_public_path__ + "static/media/649.c998305a.jpg";